import type { MerchantNavSection } from '@favelafood/shared/components/merchant/shell/nav';

export type { MerchantNavItem, MerchantNavSection } from '@favelafood/shared/components/merchant/shell/nav';

/** Staff back-office nav. Paths are base-`/` (the app owns the whole subdomain). */
export const STAFF_NAV: readonly MerchantNavSection[] = [
  { items: [
    { label: 'Dashboard', to: '/', icon: 'LayoutDashboard' },
    // badge (contagem de pendentes) injetado em runtime pelo StaffShell
    { label: 'Pendentes', to: '/pendentes', icon: 'Clock' },
  ] },
  { title: 'Cadastros', items: [
    { label: 'Comerciantes', to: '/comerciantes', icon: 'Users' },
    { label: 'Comércios', to: '/comercios', icon: 'Store' },
    // STA-10: lista/gestão de entregadores (busca, verificar, suspender).
    { label: 'Entregadores', to: '/entregadores', icon: 'Bike' },
    // Hub /novo: seus cards abrem os 3 wizards (novo-comerciante, novo-comercio e novo-entregador).
    // O atalho direto pra "Novo entregador" saiu daqui — o hub já leva ao mesmo lugar.
    { label: 'Novo cadastro', to: '/novo', icon: 'Plus' },
  ] },
  { title: 'Sistema', items: [
    { label: 'Configurações', to: '/configuracoes', icon: 'Settings' },
  ] },
];
